export const columnDescriptions = {
  ordcom: "Ordem Compra",
  codope: "Comprador",
  nomope: "Nome Comprador",
  valliq: "Valor Liquido",
  datped: "Data Pedido",
  datenc: "Data Encerramento",
  datcan: "Data Cancelamento",
  desfre: "Frete",
  codpro: "Produto",
  nompro: "Nome Produto",
  despro: "Descricao",
  qtdade: "Quantidade",
  valtot: "Valor total",
  medlar: "Largura",
  medalt: "Altura",
  unidade: "Unidade",
  qtdItens: "Itens",
  status: "Status",
};
